export default __webpack_public_path__ + "static/img5-6acca045cc46ff02e0aedafa5df720c7.jpg";